import EventScorekeeping from '@/screens/EventScorekeeping';

export default function PrivateTabsOrganizationEventEventIdScoreRoute() {
  return <EventScorekeeping basePath="/organization/event" />;
}
